export default __webpack_public_path__ + "static/media/06.ecec01a6.jpg";